/* eslint-disable @typescript-eslint/naming-convention */
/**
 * User Management Constants
 *
 * Centralized constants for user roles and object IDs used in user management.
 * These values come from the database and should be kept in sync with backend definitions.
 */

/**
 * Role name for Sector Admin users
 * This role grants administrative access to all plants within assigned sectors.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ROLE_NAME_SECTOR_ADMIN = "Sector Admin";

/**
 * Role name for Plant User users
 * This role grants plant-level permissions (Manage Users, Create Containment, Hold, Release, etc.)
 * within specific sector+plant combinations.
 */
export const ROLE_NAME_PLANT_USER = "Plant User";

/**
 * Object ID for "Manage User" permission
 * Users with this permission (S1) can manage other users for specific sector+plant combinations.
 */
export const OBJECT_ID_MANAGE_USER = "S1";

/**
 * Object ID for "Create Containment" permission
 * Users with this permission (C1) can create containments for specific sector+plant combinations.
 */
export const OBJECT_ID_CREATE_CONTAINMENT = "C1";

/**
 * Object ID for "Hold Containment" permission
 * Users with this permission (H1) can hold containments for specific sector+plant combinations.
 */
export const OBJECT_ID_HOLD_CONTAINMENT = "H1";

/**
 * Object ID for "ASRS Lock" permission
 * Users with this permission (L1) can lock ASRS containments for specific sector+plant combinations.
 */
export const OBJECT_ID_ASRS_LOCK = "L1";

/**
 * Object ID for "ASRS Unlock" permission
 * Users with this permission (L2) can unlock ASRS containments for specific sector+plant combinations.
 */
export const OBJECT_ID_ASRS_UNLOCK = "L2";

/**
 * Object ID for "Release Containment" permission
 * Users with this permission (R1) can release containments for specific sector+plant combinations.
 */
export const OBJECT_ID_RELEASE_CONTAINMENT = "R1";
